import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { NOTIFICATIONS_QUERY, SYNC_STATUS_QUERY } from '../QueryKeys';
import { getNotifications, INotification } from '../../api/getNotifications/getNotifications';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { EProductLibraryStatus, IStatus } from '../../api/getProductLibrarySyncStatus';
import { useUserTracking } from '../useUserTracking/useUserTracking';

export const useNotifications = (): UseQueryResult<INotification[]> => {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { captureException } = useUserTracking();

  return useQuery<INotification[]>({
    queryKey: NOTIFICATIONS_QUERY,
    queryFn: async () => await getNotifications(),
    initialData: [],
    refetchInterval: 5 * 1000,
    onSuccess: () => {
      // this attempts to 'synchronize' notifications with change in sync status
      const syncStatusQuery = queryClient.getQueryData<IStatus>(SYNC_STATUS_QUERY);
      if (syncStatusQuery?.sync_status === EProductLibraryStatus.PENDING) {
        queryClient.invalidateQueries(SYNC_STATUS_QUERY);
      }
    },
    onError: (err) => {
      captureException(err, { tags: { action: 'fetch_notifications' } });
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Unable to fetch notifications' });
    },
  });
};
